// @flow

import React from 'react';

import type { Node } from 'react';

type Props = {
  className: string,
  onClick: Function,
  onFocus?: Function,
  children?: Node,
  onMouseEnter?: Function,
  onMouseLeave?: Function,
  disabled?: boolean,
  customType?: string,
  type?: string
}

const Button = ({
  className,
  onClick,
  onFocus,
  children,
  disabled,
  customType,
  type,
  onMouseEnter,
  onMouseLeave
}: Props) => (
  <button
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    disabled={disabled}
    className={className}
    onClick={onClick}
    data-type={customType}
    type={type}
    onFocus={onFocus}
  >
    {children}
  </button>
);

Button.defaultProps = {
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  onFocus: () => {},
  children: null,
  disabled: false,
  customType: '',
  type: 'button'
};

export default Button;
